module.exports = require("svg-pan-zoom");